import { gql } from '@apollo/client';

const DIAGNOSIS_FRAGMENT = gql`
  fragment DiagnosisFragment on DiagnosisInfo {
    primary
    second
    physiciansNote
    patientMedications
  }
`;

export default DIAGNOSIS_FRAGMENT;
